module.exports = __webpack_public_path__ + "img/buscar.061672ac.svg";